// extracted by mini-css-extract-plugin
export default {"homeContent__top":"c-i_ct","homeContent__bottom":"c-i_cu","homeContent__cardHolder":"c-i_cv","homeContent__seoTextHolder":"c-i_cw"};